import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { User,User2 } from '../models/auth.models';
import { ApiserviceService } from './apiservice.service';

@Injectable({ providedIn: 'root' })
export class AuthfakeauthenticationService {
    private currentUserSubject: BehaviorSubject<User>;
    public currentUser: Observable<User>;
    private currentUserSubject2: BehaviorSubject<User2>;
    public currentUser2: Observable<User2>;
    personelstorage=[];
    birimadi:string;
    constructor(private http: HttpClient,private api:ApiserviceService) {
        this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
        this.currentUser = this.currentUserSubject.asObservable();
  

    }

    public get currentUserValue(): User {
        return this.currentUserSubject.value;
    }
 

    login(tcno: string, password: string) {
        return this.api.post('user/giris', { tcno, password })
            .then(user => {
                // login successful if there's a jwt token in the response
                if (user && user.data.length) {
                   

                    // store user details and jwt token in local storage to keep user logged in between page refreshes
                    localStorage.setItem('currentUser', JSON.stringify(user));
                    this.currentUserSubject.next(user);


                }
                return user;
            });
    }

 

    logout() {
        // remove user from local storage to log user out
        localStorage.removeItem('currentUser');
        this.currentUserSubject.next(null);
    }
 

   
   
}
